/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
//@ts-nocheck

import * as THREE from "three";
import React, { useRef, useState, useEffect } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { PerspectiveCamera, useGLTF } from "@react-three/drei";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import { useFrame, useLoader } from "@react-three/fiber";
//valtio state management
import { proxy, useSnapshot } from "valtio";
import { HexColorPicker } from "react-colorful";

interface state {
  current: String | null;
  currentGeometry: String | null;
  items: {
    gitenge1: String;
    shoeBottom: String;
    shoeInner: String;
    shoeShovel: String;
    shoeTop: String;
    gitenge2: String;
    gitenge3: String;
    gitenge4: String;
  };
  materials: {
    shoeBottom: String;
    shoeInner: String;
    shoeShovel: String;
    shoeTop: String;
    color: String;
  };
}

type GLTFResult = GLTF & {
  nodes: {
    dress: THREE.Mesh;
    shoeBottom: THREE.Mesh;
    shoeInner: THREE.Mesh;
    shoeShovel: THREE.Mesh;
    shoeTop: THREE.Mesh;
    Plane: THREE.Mesh;
    Plane001: THREE.Mesh;
    Plane002: THREE.Mesh;
    Plane003: THREE.Mesh;
    Plane004: THREE.Mesh;
  };
  materials: {
    color: THREE.MeshStandardMaterial;
    shoeBottom: THREE.MeshStandardMaterial;
    shoeInner: THREE.MeshStandardMaterial;
    shoeShovel: THREE.MeshStandardMaterial;
    shoeTop: THREE.MeshStandardMaterial;
    gitenge1: THREE.MeshStandardMaterial;
    gitenge2: THREE.MeshStandardMaterial;
    gitenge3: THREE.MeshStandardMaterial;
    gitenge4: THREE.MeshStandardMaterial;
  };
};

//the 3d store
let store = proxy<state>({
  current: null,
  uploadedImage: "",
  items: {
    gitenge1: "#fff",
    color: "#fff",
    shoeBottom: "#fff",
    shoeInner: "#fff",
    shoeShovel: "#fff",
    shoeTop: "#fff",
    gitenge2: "#fff",
    gitenge3: "#fff",
    gitenge4: "#fff",
  },
  materials: {
    shoeBottom: "shoeBottom",
    shoeInner: "shoeInner",
    shoeShovel: "shoeShovel",
    shoeTop: "shoeTop",
    color: "color",
  },
});

//load saved state
store = localStorage.getItem("currentState")
  ? proxy<state>(JSON.parse(localStorage.getItem("currentState")))
  : store;

let history = [];

export default function Model(props: JSX.IntrinsicElements["group"]) {
  //current state snaphot
  const snap = useSnapshot(store);
  console.log("render preview", props.renderPreview);

  useEffect(() => {
    localStorage.setItem("currentState", JSON.stringify(snap));
    localStorage.setItem("history", history);
  }, [snap]);

  interface hovered {
    mesh: THREE.Mesh | null;
  }
  //which models was hovered
  const [hovered, sethovered] = useState<hovered>({ mesh: null });

  let texture = useLoader(
    THREE.TextureLoader,
    props.uploadedImage ||
      "https://t3.ftcdn.net/jpg/00/97/11/32/240_F_97113297_P1NxOXOzB8FPGwfMEghJJhPFgxwkLPha.jpg"
  );

  const group = useRef<THREE.Group>();
  const { nodes, materials } = useGLTF("/dress-processed.glb") as GLTFResult;
  return (
    <group ref={props.previewRef || group} {...props} dispose={null}>
      <group
        rotation={[-Math.PI / 2, 0, 0]}
        onPointerOver={(e: any) => {
          e.stopPropagation();
          sethovered({ mesh: e.object.material.name });
        }}
        onPointerLeave={(e: any) => {
          e.intersections.length === 0 && sethovered({ mesh: null });
        }}
        onPointerDown={(e: any) => {
          e.stopPropagation();
          console.log(e.object.geometry);
          store.current = e.object.material.name;
          store.currentGeometry = e.object.geometry.name;
        }}
        onPointerMissed={(e: any) => {
          store.current = null;
          store.currentGeometry = null;
        }}
      >
        <mesh
          geometry={nodes.dress.geometry}
          geometry-name="color"
          material={materials[snap.materials.color]}
          material-color={snap.items.color}
        >
          {props.uploadedImage && (
            <meshStandardMaterial
              attach="material"
              map={texture}
              transparent={true}
            />
          )}
        </mesh>
        <mesh
          geometry={nodes.shoeBottom.geometry}
          geometry-name="shoeBottom"
          material={materials[snap.materials.shoeBottom]}
          material-color={snap.items.shoeBottom}
        />
        <mesh
          geometry={nodes.shoeInner.geometry}
          geometry-name="shoeInner"
          material={materials[snap.materials.shoeInner]}
          material-color={snap.items.shoeInner}
        />
        <mesh
          geometry={nodes.shoeShovel.geometry}
          geometry-name="shoeShovel"
          material={materials[snap.materials.shoeShovel]}
          material-color={snap.items.shoeShovel}
        />
        <mesh
          geometry={nodes.shoeTop.geometry}
          geometry-name="shoeTop"
          material={materials[snap.materials.shoeTop]}
          material-color={snap.items.shoeTop}
        />
      </group>
      {/* <mesh geometry={nodes.Plane.geometry} material={materials.gitenge1} position={[0, 0, 11.8]} />
      <mesh geometry={nodes.Plane001.geometry} material={materials.gitenge2} position={[0, 0, 11.8]} />
      <mesh geometry={nodes.Plane002.geometry} material={materials.gitenge3} position={[0, 0, 11.8]} />
      <mesh geometry={nodes.Plane003.geometry} material={materials.gitenge4} position={[0, 0, 11.8]} />
      <mesh geometry={nodes.Plane004.geometry} material={nodes.Plane004.material} position={[-2.83, 0.24, 11.78]} /> */}
    </group>
  );
}

export function Picker() {
  const snap = useSnapshot(store);
  // useEffect(() => {
  //   store.items.dress="red"
  // })
  return (
    <div id="color-picker">
      <div className="col-picker d-flex justify-content-between">
        <HexColorPicker
          color={snap.items[snap.currentGeometry]}
          onChange={(color) => {
            store.materials[snap.currentGeometry] = "color";
            store.items[snap.currentGeometry] = color;
            history.push(JSON.stringify(snap));
          }}
        />
      </div>
    </div>
  );
}

export function Texture() {
  const snap = useSnapshot(store);

  return (
    <div id="texture-picker">
      <h6>Textures</h6>
      <div className="different-texture d-flex justify-content-between">
        <div
          className="rounded-circle"
          onClick={(e) => {
            e.preventDefault();
            store.items[snap.currentGeometry] = "#fff";
            store.materials[snap.currentGeometry] = "gitenge1";
            history.push(JSON.stringify(snap));
          }}
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/src/texture1.jpg")`,
          }}
        ></div>
        <div
          className="rounded-circle"
          onClick={(e) => {
            e.preventDefault();
            store.items[snap.currentGeometry] = "#fff";
            store.materials[snap.currentGeometry] = "gitenge2";
            history.push(JSON.stringify(snap));
          }}
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/src/texture2.jpg")`,
          }}
        ></div>
        <div
          className="rounded-circle"
          onClick={(e) => {
            e.preventDefault();
            store.items[snap.currentGeometry] = "#fff";
            store.materials[snap.currentGeometry] = "gitenge3";
            history.push(JSON.stringify(snap));
          }}
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/src/texture3.jpg")`,
          }}
        ></div>
        <div
          className="rounded-circle"
          onClick={(e) => {
            e.preventDefault();
            store.items[snap.currentGeometry] = "#fff";
            store.materials[snap.currentGeometry] = "gitenge4";
            history.push(JSON.stringify(snap));
          }}
          style={{
            backgroundImage: `url("${process.env.PUBLIC_URL}/src/texture4.jpg")`,
          }}
        ></div>
      </div>
    </div>
  );
}

useGLTF.preload("/dress-processed.glb");
